import { _js } from '@ifixit/localize';
import { TiptapButton } from '../TiptapButton';
import { faIndent } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEditorContext } from '../../editor_context';

export const IndentButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
         isDisabled={!editor.can().sinkListItem('listItem')}
         icon={<FontAwesomeIcon icon={faIndent} />}
         title={_js('Increase indent')}
         overrideShortcut={'tab'}
      />
   );
};
